<div class="esim-selection-modal">
  <button (click)="closeModal()" class="close-button flex-center default-button">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M5.82739 3.63512L12.0034 9.81113L18.1474 3.66712C18.2831 3.52267 18.4466 3.40712 18.628 3.32738C18.8095 3.24765 19.0052 3.20539 19.2034 3.20312C19.6277 3.20313 20.0347 3.3717 20.3348 3.67175C20.6348 3.97181 20.8034 4.37878 20.8034 4.80313C20.8071 4.99929 20.7707 5.19414 20.6964 5.37574C20.6221 5.55733 20.5115 5.72182 20.3714 5.85913L14.1474 12.0031L20.3714 18.2271C20.6351 18.4851 20.7897 18.8345 20.8034 19.2031C20.8034 19.6275 20.6348 20.0344 20.3348 20.3345C20.0347 20.6346 19.6277 20.8031 19.2034 20.8031C18.9995 20.8116 18.796 20.7775 18.606 20.7032C18.4159 20.6288 18.2434 20.5157 18.0994 20.3711L12.0034 14.1951L5.84339 20.3551C5.70819 20.4948 5.54669 20.6062 5.36819 20.6831C5.18969 20.76 4.99773 20.8008 4.80339 20.8031C4.37904 20.8031 3.97207 20.6346 3.67201 20.3345C3.37196 20.0344 3.20339 19.6275 3.20339 19.2031C3.19965 19.007 3.23605 18.8121 3.31034 18.6305C3.38462 18.4489 3.49524 18.2844 3.63539 18.1471L9.85939 12.0031L3.63539 5.77912C3.37168 5.52114 3.21705 5.17178 3.20339 4.80313C3.20339 4.37878 3.37196 3.97181 3.67201 3.67175C3.97207 3.3717 4.37904 3.20313 4.80339 3.20312C5.18739 3.20793 5.55539 3.36312 5.82739 3.63512Z"
        fill="black"
      />
    </svg>
  </button>

  <h3 class="primary-font-semibold heading">{{ 'esim_selection_dialog.title' | translate }}</h3>

  <hr class="divider" />

  <div class="esim-list">
    @for (sim of simsService.sims(); track sim.esimId) {
      @if (
        SimStatesMapping[sim.eSimState] !== InternalSimStates.Deleted &&
        sim.imsiId.toString() === imsiId()
      ) {
        <div class="esim-item">
          <div class="d-flex justify-content-start">
            <app-status-tag [status]="SimStatesMapping[sim.eSimState]"> </app-status-tag>
          </div>

          <div class="esim-item-content">
            <div class="esim-item-content-left">
              <p class="primary-font-semibold esim-name">{{ sim.name }}</p>
              <p class="primary-font-medium esim-iccid"><span>ICCID:</span> {{ sim.iccid }}</p>
            </div>

            <button class="esim-item-content-right default-button" (click)="goToCheckout(sim)">
              <app-arrow [svgClass]="'esim-item-content-right-t1-arrow-icon'"></app-arrow>
            </button>
          </div>
        </div>
      }
    }
  </div>

  <div class="not-sure-about-esim">
    @if (inventoryAvailability()) {
      <p class="primary-font-bold not-sure-heading">
        {{ 'esim_selection_dialog.not_sure_about_esim' | translate }}
      </p>
    }
    @if (!inventoryAvailability()) {
      <p class="primary-font-medium inventory_unavailable">
        {{ 'esim_selection_dialog.inventory_unavailable' | translate }}
      </p>
    }

    <button
      [disabled]="!inventoryAvailability()"
      [class.opacity-50]="!inventoryAvailability()"
      (click)="goToCheckout()"
      class="primary-button rounded-pill custom-button get-esim-button flex-center"
    >
      <span class="primary-font-regular button-text">{{
        'esim_selection_dialog.get_new_esim' | translate
      }}</span>
      <app-arrow [svgClass]="'get-esim-t1-arrow-icon'"></app-arrow>
    </button>
  </div>

  <p class="primary-font-medium esim-description">
    {{ 'esim_selection_dialog.esim_description' | translate }}
  </p>
</div>
